import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NewRelicService } from '@core/services/utility/new-relic.service';


import { PermissionsService } from '@core/services/utility/permissions.service';

@Component({
    selector: 'app-root',
    imports: [        
        RouterOutlet,
    ],
    providers: [],
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnDestroy,OnInit {
    private permissionsService = inject(PermissionsService);
    private newRelicService = inject(NewRelicService);

    title = 'Camms.Risk.Client';
   
    ngOnInit(): void {
        this.newRelicService.setAgent();
        this.newRelicService.setUserAttributes();
    }

    ngOnDestroy() {
        this.permissionsService.unsubscribeAll();
    }
}
